export const environment: any = {
    production: false,
    apiUrl: 'https://desa-api.bo.garantor.com.ar',
    projectTitle: 'Desarrollo - Garantor',
    decidirUrl: 'https://developers.decidir.com/api/v2',
    decidirPublicApiKey: '1EfiWcIo4R3MAJ3Q4j9C6gWK4FCCClF5',
    //captchaKey: '6LfT2PkaAAAAAHn5_A8JsARXpXZargCRd-yo1k_D',
    version: require('../../package.json').version + '-dev',
};
